(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
const videos = document.querySelectorAll('.password-container--bg video');

videos.forEach((video) => {
video.muted = true;
video.playsInline = true;

const playVideo = () => {
  video.play().catch(() => {});
};

if (video.readyState >= 2) {
  playVideo();
} else {
  video.addEventListener('loadeddata', playVideo, { once: true });
}

});
});

  } catch(e) { console.error(e); }
})();
})();
